<template>
  <div class="container flex flex-col items-center">
    <div class=" flex flex-col items-center w-full" v-if="!user.id">
      <el-avatar :size="60" :src="icon" @error="errorHandler"></el-avatar>
      <div class="text-xl pt-1">{{  $t('Hi! 你好') }}</div>
      <div class="flex login items-center space-x-2" >
        <div class=" left " @click="signDialog = true,type='login'">{{ $t('立即登录') }}</div>
        <div class="right" @click="signDialog = true,type='register'">{{ $t('注册') }}</div>
      </div>
      
    </div>
    <div v-else class=" flex flex-col items-center w-full">
      <el-avatar :size="60" :src="user.icon" @error="errorHandler"></el-avatar>
      <div class="text-xl pt-1">{{  user.name ? user.name : $t('暂未设置昵称') }}</div>
      <div class="flex items-center cursor-pointer " @click="showAddrLists=true">
         <span class="iconfont icon-shouhuodi text-main"></span>
         <span style="font-size: 0.98rem;" class="truncate max-w-9rem">{{ user.address.address ? user.address.address : $t('请选择地址') }}</span>
         <span class="iconfont icon-right"></span>
      </div>
      <div  class="flex space-x-2 w-full px-3 pt-4">
        <div class="flex-col flex cursor-pointer" v-for="tab in tabs" :key="tab.icon" @click="$goTo(tab.url)">
          <span class="iconfont" :class="tab.icon"></span>
          <span class="text-xs truncate max-w-3.5rem" >{{ tab.name }}</span>
        </div>
      </div>
    </div>
    <div class="img-box flex flex-col items-center w-full">
      <img :src="$smallImage('https://irutils.inruan.com/utils/qrcode?text=https://int.huaeb.com/app/download.html&logo=https://cdn-qn-hours.inruan.com/hours/X1/20260122/FlAQaULCKe2OTN1LkKBsoDZ5IUsC.png')" class="encode">
      <div class="space-x-2 pt-2">
        <span style="border-right:1px solid #DCDCDC;padding-right: 0.5rem;">{{ $t('手机版') }}</span>
        <span>{{ $t('让买花更方便') }}</span>
      </div>
    </div>
    <login :show.sync="signDialog" @change="signDialog = false" :type="type"></login>
    <AddrTable :show="showAddrLists" @modifyAddr="modifyAddr" @close="showAddrLists = false" ></AddrTable>
    
  </div>
</template>

<script>
import Login from "@/components/home/login.vue";
import AddrTable from "@/components/mine/addrTable.vue";


import { computed, ref } from "@vue/composition-api"
import { $smallImage } from "../../common/utils";
export default {
  components: { Login,AddrTable },
  setup(props, ctx) {
    const user = computed(() => ctx.root.$store.getters.user);
    const errorHandler = () => {
      return 'https://cdn-qn.huaeb.com/sellmall/U2o9X1/20230323/FlDCLGkBDuf0YUrzKrh3ugtRMBq-.png'
    }
    const icon = 'https://cdn-qn.huaeb.com/sellmall/U2o9X1/20230323/FlDCLGkBDuf0YUrzKrh3ugtRMBq-.png'
    const signDialog = ref(false)
    const type = ref('login')
    const tabs = [
      {
        name: ctx.root.$t('收货地址'),
        url: '/mine/address',
        icon: 'icon-shouhuodizhi'

      },
      {
        name: ctx.root.$t('我的钱包'),
        url: '/mine/wallet',
        icon: 'icon-qianbao'


      },
      {
        name: ctx.root.$t('我的收藏'),
        url: '/mine/favorite',
        icon: 'icon-shoucang'

      },
      {
        name: ctx.root.$t('更多'),
        url: '/mine/center',
        icon: 'icon-quanbudingdan'
      }
    ]
    const showAddrLists = ref(false)
    const setLockAddress = async (aid,val) => {
      let res = await ctx.root.$callapi('user/setLockDefaultAddress', {
        aid
      })
      if (res.code == 0 && res.data) {
        ctx.root.$store.commit('SET_ADDRESS', res.data)
        ctx.root.$store.commit('SET_LOCKADDRESS',val)

      }
    }
    const modifyAddr = (val) => {
      showAddrLists.value = false
      setLockAddress(val.id,val)
    }

    
    return { user, icon, signDialog, tabs,errorHandler,showAddrLists,modifyAddr,type }
  },
}
</script>

<style scoped lang="scss">::v-deep .datersel>input {
  --tw-bg-opacity: 1;
  background-color: rgba(244, 244, 244, var(--tw-bg-opacity));
  border-width: 0px;
}
::v-deep .datersel>span {
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  -webkit-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -ms-transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  --tw-scale-z: 0.8;
}
::v-deep .citysel>div>input {
  --tw-bg-opacity: 1;
  background-color: rgba(244, 244, 244, var(--tw-bg-opacity));
  border-width: 0px;
}
.login {
  padding-top: 1.75rem;
  padding-left: 1.66rem;
  padding-right: 1.66rem;
  width: 100%;
}
.login>div {
  font-size: 0.94rem;
  border-radius: 1.5rem;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 2.3rem;
  width: 50%;
}
.login .left {
  background-color: #34B66B;
  color: white;
  white-space: nowrap;
}
.login .right {
  border: 0.083rem solid #E1E1E1;
}
.img-box {
  margin-top: 1.62rem;
  border-top: 0.031rem solid #E7E7E7;
  padding-top: 1.4rem;
  font-size: 0.875rem;
}
.img-box .encode {
  width: 6.25rem;
  height: 6.25rem;
}</style>
